import { getThemeColor, Styles } from "@mcleod/core";

const defaultBorderColor = getThemeColor("strokeSecondary");
const primaryColor = getThemeColor("primary");
const subtleLightestColor = getThemeColor("subtle.lightest");

export const UnitInputFieldStyles = Styles.make("vu", () => {
    return {
        textboxDiv: {
            display: "flex"
        },
        textboxNumber: {
            borderBottom: "1px solid " + defaultBorderColor,
            borderLeft: "1px solid " + defaultBorderColor,
            borderRight: "1px solid " + defaultBorderColor,
            borderTop: "1px solid " + defaultBorderColor,

            borderBottomLeftRadius: "4px",
            borderBottomRightRadius: "0px",
            borderTopLeftRadius: "4px",
            borderTopRightRadius: "0px"
        },
        textboxNumberFocused: {
            borderBottomColor: primaryColor + "!important",
            borderLeftColor: primaryColor + "!important",
            borderRightColor: defaultBorderColor + "!important",
            borderTopColor: primaryColor + "!important"
        },
        textboxUnit: {
            borderBottom: "1px solid " + defaultBorderColor,
            borderRight: "1px solid " + defaultBorderColor,
            borderTop: "1px solid " + defaultBorderColor,
            borderLeft: "0px solid " + defaultBorderColor,

            borderBottomLeftRadius: "0px",
            borderBottomRightRadius: "4px",
            borderTopLeftRadius: "0px",
            borderTopRightRadius: "4px"
        },
        textboxUnitFocused: {
            borderBottomColor: primaryColor + "!important",
            borderRightColor: primaryColor + "!important",
            borderTopColor: primaryColor + "!important"
        },
        textboxUnit_hoverEnabled: {
            "&:hover:not(:disabled)": {
                backgroundColor: subtleLightestColor
            }
        },
        textboxUnit_hoverEnabledWithBackgroundColor: {
            "&:hover:not(:disabled)": {
                boxShadow: "0 0 0 100vmax inset rgb(0 0 0/20%) !important"
            }
        }
    }
});
